<template>
  <div class="mapbox" ref="mapbox">
      
  </div>
</template>

<script>
// import Mapbox from 'mapbox-gl/dist/mapbox-gl.js'
import Mapbox from 'mapbox-gl'
import ZoomControl from 'mapbox-gl-controls/lib/zoom';

export default {
  name: 'mapbox',
  props: {
    data: {}
  },
  data() {
    return {
     
    }
  },
  mounted() {
    
    if(this.data.map) {
      
      Mapbox.accessToken = this.data.map.accessToken;
  
      let map = new Mapbox.Map({
        container: this.$refs.mapbox,
        style: this.data.map.styleUrl
      });
      map.scrollZoom.disable();
      
      map.addControl(new ZoomControl(), 'top-right');

      map.on('click', 'artvenues', e => {

        if(e.features[0].properties.id) {
          const id = e.features[0].properties.id;
          this.$emit('click-venue', id);
        }
        // var coordinates = e.features[0].geometry.coordinates.slice();
        // var description = e.features[0].properties.description;
        
        // // Ensure that if the map is zoomed out such that multiple
        // // copies of the feature are visible, the popup appears
        // // over the copy being pointed to.
        // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        // coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        // }
        
        // new mapboxgl.Popup()
        // .setLngLat(coordinates)
        // .setHTML(description)
        // .addTo(map);
      });
      
    
    } else {
        alert('missing map from JSON')
    }
  }


}
</script>


<style scoped lang="scss">
  .mapbox {
    height:30rem;
    margin-bottom: 0.5rem;
  }

</style>
